import { defineAction } from './types';

export default defineAction({
  action: 'CREATE_MEETING_NOTES',
  getHref: attrs => `/meetings/${attrs.event_id}/meeting-note`,
  getFollowUp: () => null,
  completionEvents: ['MEETING_NOTE_GENERATED'],
});
